export enum FILTER_NAME {
  ARTIST = 'artist',
  DOMINANT_COLOR = 'dominant_color',
  PRICE = 'price',
  TYPE = 'type',
  SUB_CATEGORY = 'sub_category',
  SIZE = 'size',
}

export const FILTER_ORDER = [
  FILTER_NAME.PRICE,
  FILTER_NAME.SIZE,
  FILTER_NAME.TYPE,
  FILTER_NAME.SUB_CATEGORY,
  FILTER_NAME.DOMINANT_COLOR,
  FILTER_NAME.ARTIST,
];

export const DEFAULT_FILTER_NAMES: Record<string, string> = {
  [FILTER_NAME.ARTIST]: 'Artist',
  [FILTER_NAME.DOMINANT_COLOR]: 'Dominant Color',
  [FILTER_NAME.PRICE]: 'Price',
  [FILTER_NAME.TYPE]: 'Category',
  [FILTER_NAME.SUB_CATEGORY]: 'Medium',
  [FILTER_NAME.SIZE]: 'Size',
};

export const FILTER_CONTAINER_TEST_ID = 'filter-container-test-id';

export const FILTER_DOMINANT_COLORS: Record<string, string> = {
  red: '#cc0000',
  orange: '#ee6600',
  yellow: '#ffcc00',
  green: '#009900',
  blue: '#0000cc',
  purple: '#990099',
  black: '#000000',
  white: '#eeeeee',
  brown: '#663300',
  gray: '#999999',
  pink: '#ee00bb',
  silver: 'linear-gradient(0deg, #cccccc 0%, #999999 100%)',
  gold: 'linear-gradient(0deg, #B48420 0%, #8A6E2F 100%)',
  bronze: 'linear-gradient(0deg, #C96A1E 0%, #9E592C 100%)',
  ['multi_color']:
    'linear-gradient(to top, rgba(255, 0, 0, 1) 0%, rgba(255, 255, 0, 1) 15%, rgba(0, 255, 0, 1) 30%, rgba(0, 255, 255, 1) 50%, rgba(0, 0, 255, 1) 65%, rgba(255, 0, 255, 1) 80%, rgba(255, 0, 0, 1) 100%)',
};

export const MIN_PRICE = 'minPrice';
export const MAX_PRICE = 'maxPrice';
